import { asyncReducer } from 'redux-promise-middleware-actions';
import { setLocalStorage, clearLocalStorage } from 'Utils/localStorage';
import moment from 'moment';
import { localStorageKey } from '../../Components/Card/Events/Details/About/GoLive/constants';
import { addSimuliveRecordingAction,
  clearPastFilteredWebinarsAction,
  clearUpcomingFilteredWebinarsAction,
  createBroadcastSessionAction,
  getActiveTargetsStatusAction,
  stopBroadcastSessionAction,
  deleteWebinarAction,
  editOrganizersAction,
  editPanelistsAction,
  getAutoRecordedAction,
  getOrganizerAudioSettingsAction,
  getBroadcastStatusAction,
  getPanelistsAction,
  getPastWebinarsAction,
  getSeriesRecurrenceAction,
  getFutureSeriesRecurrenceAction,
  getSimuliveRecording,
  getSupportedWebinarTypes,
  getWebinarAllDetails,
  getWebinarAttendanceAction,
  getWebinarDetailsAction,
  getWebinarTimeZones,
  postWebinarAudioSettingsAction,
  startWebinarAction,
  updateOrganizersAction,
  updateSeriesRecurrenceAction,
  updateSimuliveRecording,
  updateWebinarAutoRecordedAction,
  updateWebinarBrandingAction,
  updateWebinarDetailsAction,
  setLiveStreamingConfigAction,
  getLiveStreamingConfigAction,
  getLinkedinConfigAction,
  getAllLiveStreamingConfigurationAction,
  updateLiveStreamingChannelConfigAction,
  linkedInReloginAction,
  reassignWebinarAction } from './actions';

import { deleteWebinar,
  getEditedSpeakers,
  getUpdatedSpeakers,
  getIsPastWebinar,
  updateRecurrenceDetails,
  updateWebinar } from './webinarDetailsHelper';

export const upcomingWebinarId = 'upcoming';
export const pastWebinarId = 'past';

const defaultState = {
  isFetchingRecurrenceSeries: false,
  isUpdatingSimuliveRecording: false,
  isReassigned: false,
  organizerSettings: {
    isFetching: false,
    isVideoLibraryEnabled: true,
    isRestrictAccountUserSearchEnabled: false
  },
  audio: {},
  autoRecorded: {},
  branding: {},
  handouts: {},
  organizers: {},
  panelists: {},
  seriesRecurrence: {},
  futureSeriesRecurrence: {},
  simuliveRecording: {},
  supportedWebinarTypes: {},
  webinarAllDetails: {},
  attendance: {
    fetchingKeys: [],
    failedKeys: [],
    data: {}
  },
  pastWebinar: {
    pagination: {},
    isFetching: false
  },
  broadcastStatus: {},
  availableStreamConfig: {},
  isLoading: false,
  isSessionInitiated: false,
  liveStreamingSuccessMsg: {},
  updatedAvailableStreamConfig: {},
  configFlag: false,
  configurationChannels: {},
  linkedinConfig: {},
  updateLivestreamingConfig: {},
  collapsed: true,
  activeChannels: [],
  linkedinReLoginRequired: false
};

const simuliveRecordingReducer = asyncReducer(getSimuliveRecording);
const timezonesReducer = asyncReducer(getWebinarTimeZones);
const webinarAllDetailsReducer = asyncReducer(getWebinarAllDetails);

export default (newState = defaultState, action) => {
  const state = {
    ...newState,
    simuliveRecording: simuliveRecordingReducer(newState.simuliveRecording, action),
    timezones: timezonesReducer(newState.timezones, action),
    webinarAllDetails: webinarAllDetailsReducer(newState.webinarAllDetails, action)
  };

  switch (action.type) {
    case getPastWebinarsAction.toString(): {
      return {
        ...state,
        pastWebinar: {
          ...state.pastWebinar,
          isFetching: true,
          error: undefined
        }
      };
    }

    case createBroadcastSessionAction.complete.toString(): {
      setLocalStorage(`broadCastStatus_${action.channel}`, JSON.stringify(action.data));
      return {
        ...state,
        isLoading: false
      };
    }

    case createBroadcastSessionAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isSessionInitiated: true
      };
    }
    case createBroadcastSessionAction.failed.toString(): {
      if (action.config) {
        setLocalStorage(localStorageKey.liveStreamingId, action.config.liveStreamingSettingsId);
      }
      return {
        ...state,
        linkedinReLoginRequired: action.relogin,
        isLoading: false
      };
    }

    case linkedInReloginAction.complete.toString(): {
      clearLocalStorage(localStorageKey.linkedinAuthCodeReLogin);
      clearLocalStorage(localStorageKey.reloginRequired);
      return {
        ...state,
        isLoading: false
      };
    }

    case linkedInReloginAction.toString(): {
      return {
        ...state,
        isLoading: true
      };
    }
    case linkedInReloginAction.failed.toString(): {
      clearLocalStorage(localStorageKey.linkedinAuthCodeReLogin);
      clearLocalStorage(localStorageKey.reloginRequired);
      return {
        ...state,
        isLoading: false
      };
    }

    case getActiveTargetsStatusAction.complete.toString(): {
      return {
        ...state,
        activeChannels: action.data,
        isLoading: false
      };
    }

    case getActiveTargetsStatusAction.toString(): {
      return {
        ...state,
        isLoading: true
      };
    }
    case getActiveTargetsStatusAction.failed.toString(): {
      return {
        ...state,
        isLoading: false
      };
    }

    case stopBroadcastSessionAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isSessionInitiated: true
      };
    }

    case stopBroadcastSessionAction.complete.toString(): {
      clearLocalStorage(`broadCastStatus_${action.channel}`);
      const broadcastStatus = { ...state.broadcastStatus };
      delete broadcastStatus[action.channel];
      return {
        ...state,
        broadcastStatus,
        isLoading: false
      };
    }

    case stopBroadcastSessionAction.failed.toString(): {
      return {
        ...state,
        isLoading: false
      };
    }

    case getBroadcastStatusAction.complete.toString(): {
      return {
        ...state,
        broadcastStatus: {
          ...state.broadcastStatus,
          [action.channel]: action.data
        },
        isLoading: action.data.status !== 'connected' && state.isSessionInitiated === true,
        isSessionInitiated: false
      };
    }

    case getBroadcastStatusAction.failed.toString(): {
      if (action.channel) {
        clearLocalStorage(`broadCastStatus_${action.channel}`);
      }
      return {
        ...state,
        broadcastStatus: {},
        isLoading: false
      };
    }

    case getLiveStreamingConfigAction.toString(): {
      return {
        ...state,
        isLoading: true
      };
    }

    case getLiveStreamingConfigAction.complete.toString(): {
      return {
        ...state,
        updatedAvailableStreamConfig: {
          ...state.updatedAvailableStreamConfig,
          [action.data.channelType]: action.data
        },
        isLoading: false
      };
    }

    case getLiveStreamingConfigAction.failed.toString(): {
      return {
        ...state,
        availableStreamConfig: {},
        updatedAvailableStreamConfig: {},
        isLoading: false
      };
    }

    case setLiveStreamingConfigAction.complete.toString(): {
      return {
        ...state,
        configurationChannels: {
          ...state.configurationChannels,
          configFlag: true,
          [action.channel]: action.channel,
          ...action.data
        },
        isLoading: false
      };
    }

    case setLiveStreamingConfigAction.toString(): {
      return {
        ...state,
        isLoading: true,
        configFlag: false
      };
    }
    case setLiveStreamingConfigAction.failed.toString(): {
      return {
        ...state,
        configurationChannels: {},
        isLoading: false,
        configFlag: false,
        enableLivestreamFlag: action.showEnableLivestreamMessage,
        multiCompanyPageFlag: action.showMultiCompanyPageMessage,
        accountType: action.accountType
      };
    }

    case updateLiveStreamingChannelConfigAction.toString(): {
      return {
        ...state,
        isLoading: true,
        configFlag: false
      };
    }

    case updateLiveStreamingChannelConfigAction.complete.toString(): {
      return {
        ...state,
        updateLivestreamingConfig: {
          ...state.configurationChannels,
          liveStreamingSettingsId: action.data.liveStreamingSettingsId,
          [action.channel]: action.channel
        },
        isLoading: false
      };
    }

    case updateLiveStreamingChannelConfigAction.failed.toString(): {
      return {
        ...state,
        updateLivestreamingConfig: {},
        isLoading: false,
        configFlag: false
      };
    }

    case getLinkedinConfigAction.toString(): {
      return {
        ...state,
        isLoading: false,
        collapsed: true
      };
    }

    case getLinkedinConfigAction.complete.toString(): {
      return {
        ...state,
        linkedinConfig: {
          // ...state.linkedinConfig,
          data: action.data,
          collapsed: false
        },
        isLoading: false
      };
    }

    case getLinkedinConfigAction.failed.toString(): {
      return {
        ...state,
        linkedinConfig: {},
        isLoading: false,
        collapsed: true,
        configFlag: false
      };
    }

    case getAllLiveStreamingConfigurationAction.toString(): {
      return {
        ...state,
        isLoading: true
      };
    }
    case getAllLiveStreamingConfigurationAction.complete.toString(): {
      return {
        ...state,
        isLiveStreamConfiguration: {
          ...state.liveStreamingSuccessMsg,
          data: action.data
        },
        configurationChannels: {},
        updatedAvailableStreamConfig: {},
        isLoading: false,
        configFlag: false
      };
    }

    case getAllLiveStreamingConfigurationAction.failed.toString(): {
      return {
        ...state,
        liveStreamingSuccessMsg: {},
        isLoading: false,
        configurationChannels: {},
        updatedAvailableStreamConfig: {}
      };
    }

    case getPastWebinarsAction.complete.toString(): {
      return {
        ...state,
        pastWebinar: {
          ...state.pastWebinar,
          data: action.data.webinars,
          pagination: {
            limit: action.data.limit,
            page: action.data.page,
            next: action.data.next,
            previous: action.data.previous,
            pageSize: action.data.pageSize,
            total: action.data.total
          },
          isFetching: false
        }
      };
    }

    case getPastWebinarsAction.failed.toString(): {
      return {
        ...state,
        pastWebinar: {
          ...state.pastWebinar,
          isFetching: true,
          error: action.message
        }
      };
    }

    case clearPastFilteredWebinarsAction.complete.toString(): {
      return {
        ...state,
        pastFilteredWebinars: {
          ...defaultState.pastFilteredWebinars
        }
      };
    }

    case clearPastFilteredWebinarsAction.failed.toString(): {
      return {
        ...state,
        pastFilteredWebinars: {
          ...defaultState.pastFilteredWebinars
        }
      };
    }

    case clearUpcomingFilteredWebinarsAction.complete.toString(): {
      return {
        ...state,
        upcomingFilteredWebinars: {
          ...defaultState.upcomingFilteredWebinars
        }
      };
    }

    case clearUpcomingFilteredWebinarsAction.failed.toString(): {
      return {
        ...state,
        upcomingFilteredWebinars: {
          ...defaultState.upcomingFilteredWebinars
        }
      };
    }

    case deleteWebinarAction.toString(): {
      return {
        ...state,
        isDeleting: true
      };
    }

    case deleteWebinarAction.complete.toString(): {
      const copySeriesRecurrence = Object.assign({}, state.seriesRecurrence);
      if (action && action.recurrenceKey) {
        const recurrence = Object.assign({}, copySeriesRecurrence[action.recurrenceKey]);
        const webinarTimes = recurrence.webinarTimes.filter((time) => action.webinarKey !== time.webinarKey);
        recurrence.webinarTimes = webinarTimes;
        copySeriesRecurrence[action.recurrenceKey] = recurrence;
      }
      const newUpcomingWebinar = deleteWebinar(action.webinarKey, state.upcomingWebinar.data);
      return {
        ...state,
        upcomingWebinar: {
          ...state.upcomingWebinar,
          data: newUpcomingWebinar
        },
        seriesRecurrence: copySeriesRecurrence,
        isDeleting: false
      };
    }

    case deleteWebinarAction.failed.toString(): {
      return {
        ...state,
        deleteWebinarError: action.error,
        isDeleting: false
      };
    }

    case getPanelistsAction.toString(): {
      return {
        ...state
      };
    }

    case getPanelistsAction.complete.toString(): {
      state.panelists[action.webinarKey] = action.data[0];
      return {
        ...state
      };
    }

    case getPanelistsAction.failed.toString(): {
      return {
        ...state,
        error: action.message
      };
    }

    case reassignWebinarAction.toString(): {
      return {
        ...state
      };
    }

    case reassignWebinarAction.complete.toString(): {
      return {
        ...state,
        isReassigned: true
      };
    }

    case reassignWebinarAction.failed.toString(): {
      return {
        ...state,
        error: action.message
      };
    }

    case getWebinarDetailsAction.complete.toString(): {
      const [audio, organizers, branding] = action.data;
      const newAudio = Object.assign({}, state.audio);
      const newBranding = Object.assign({}, state.branding);
      const newOrganizers = Object.assign({}, state.organizers);
      const allNumbers = [];
      for (const countryCode in audio.phoneNumbers) {
        if (Object.prototype.hasOwnProperty.call(audio.phoneNumbers, countryCode)) {
          const numbers = audio.phoneNumbers[countryCode];
          if (numbers.toll) {
            allNumbers.push({ country: countryCode, number: numbers.toll, tollFree: false });
          }
          if (numbers.tollFree) {
            allNumbers.push({ country: countryCode, number: numbers.tollFree, tollFree: true });
          }
        }
      }
      audio.allNumbers = allNumbers;
      newAudio[action.webinarKey] = audio;
      newBranding[action.webinarKey] = branding;
      newOrganizers[action.webinarKey] = organizers;
      return {
        ...state,
        audio: newAudio,
        organizers: newOrganizers,
        branding: newBranding
      };
    }

    case getWebinarDetailsAction.failed.toString(): {
      return {
        ...state,
        detailsError: action.message
      };
    }

    case updateWebinarDetailsAction.toString(): {
      return {
        ...state,
        isUpdatingWebinarDetails: true
      };
    }

    case updateWebinarDetailsAction.complete.toString(): {
      const isPastWebinar = getIsPastWebinar(action.webinarKey, state.upcomingWebinar?.data, state.pastWebinar?.data, action.details);
      const newWebinars = updateWebinar(action.details, action.webinarKey, state, isPastWebinar);
      if (isPastWebinar) {
        return {
          ...state,
          pastWebinar: {
            ...state.pastWebinar,
            data: newWebinars
          },
          isUpdatingWebinarDetails: false,
          detailsError: null
        };
      }
      return {
        ...state,
        upcomingWebinar: {
          ...state.upcomingWebinar,
          data: newWebinars
        },
        isUpdatingWebinarDetails: false,
        detailsError: null
      };
    }

    case updateWebinarDetailsAction.failed.toString(): {
      return {
        ...state,
        isUpdatingWebinarDetails: false,
        detailsError: action.message
      };
    }

    case getSupportedWebinarTypes.complete.toString(): {
      return {
        ...state,
        supportedWebinarTypes: action.supportedTypes
      };
    }

    case updateWebinarBrandingAction.complete.toString(): {
      return {
        ...state,
        branding: {
          ...state.branding,
          [action.webinarKey]: action.data
        }
      };
    }

    case editOrganizersAction.toString():
    case editPanelistsAction.toString(): {
      return {
        ...state,
        isEditingSpeaker: true
      };
    }

    case editPanelistsAction.complete.toString(): {
      const [added] = action.data;
      const newPanelists = getEditedSpeakers(state.panelists, action.webinarKey, true, added, action.deleteKeys);
      return {
        ...state,
        isEditingSpeaker: false,
        panelists: newPanelists,
        detailsError: null
      };
    }

    case editPanelistsAction.failed.toString(): {
      return {
        ...state,
        isEditingSpeaker: false,
        detailsError: action.message
      };
    }

    case editOrganizersAction.complete.toString(): {
      const [added] = action.data;
      const newOrganizers = getEditedSpeakers(state.organizers, action.webinarKey, false, added, action.deleteKeys);
      return {
        ...state,
        isEditingSpeaker: false,
        organizers: newOrganizers,
        detailsError: null
      };
    }

    case editOrganizersAction.failed.toString(): {
      return {
        ...state,
        isEditingSpeaker: false,
        detailsError: action.message
      };
    }

    case updateOrganizersAction.fulfilled.toString(): {
      const edited = action.payload.updatedOrganizers;
      const newOrganizers = getUpdatedSpeakers(state.organizers, action.payload.webinarKey, edited, action.payload.updatedKeys);
      return {
        ...state,
        isEditingSpeaker: false,
        organizers: newOrganizers,
        detailsError: null
      };
    }

    case postWebinarAudioSettingsAction.complete.toString(): {
      const [audio] = action.data;
      const newAudio = Object.assign({}, state.audio);
      const allNumbers = [];
      for (const countryCode in audio.phoneNumbers) {
        if (Object.prototype.hasOwnProperty.call(audio.phoneNumbers, countryCode)) {
          const numbers = audio.phoneNumbers[countryCode];
          if (numbers.toll) {
            allNumbers.push({ country: countryCode, number: numbers.toll, tollFree: false });
          }
          if (numbers.tollFree) {
            allNumbers.push({ country: countryCode, number: numbers.tollFree, tollFree: true });
          }
        }
      }
      audio.allNumbers = allNumbers;
      newAudio[action.webinarKey] = audio;
      return {
        ...state,
        audio: newAudio
      };
    }

    case updateWebinarAutoRecordedAction.fulfilled.toString():
    case getAutoRecordedAction.complete.toString(): {
      state.autoRecorded[action.payload.webinarKey] = action.payload.autoRecordEnabled;
      return {
        ...state
      };
    }

    case getOrganizerAudioSettingsAction.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          audio: {},
          isFetching: true
        }
      };
    }

    case getOrganizerAudioSettingsAction.complete.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          audio: action.data,
          isFetching: false
        }
      };
    }

    case getOrganizerAudioSettingsAction.failed.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: false
        }
      };
    }

    default: {
      return state;
    }

    /* ------------ Attendance ----------------- */
    case getWebinarAttendanceAction.toString(): {
      const fetchingKeys = [...state.attendance.fetchingKeys];
      fetchingKeys.push(action.webinarKey);
      const failedKeys = [...state.attendance.failedKeys];
      return {
        ...state,
        attendance: {
          ...state.attendance,
          failedKeys: failedKeys.filter((key) => key !== action.webinarKey),
          fetchingKeys
        }
      };
    }
    case getWebinarAttendanceAction.complete.toString(): {
      const fetchingKeys = [...state.attendance.fetchingKeys];
      return {
        ...state,
        attendance: {
          ...state.attendance,
          fetchingKeys: fetchingKeys.filter((key) => key !== action.webinarKey),
          data: {
            ...state.attendance.data,
            [action.webinarKey]: { ...action.attendanceStats, timestamp: moment() }
          }
        }
      };
    }
    case getWebinarAttendanceAction.failed.toString(): {
      const failedKeys = [...state.attendance.failedKeys];
      const fetchingKeys = [...state.attendance.fetchingKeys];
      failedKeys.push(action.webinarKey);
      return {
        ...state,
        attendance: {
          ...state.attendance,
          fetchingKeys: fetchingKeys.filter((key) => key !== action.webinarKey),
          failedKeys
        }
      };
    }

    /* ------------ Start Webinar ----------------- */
    case startWebinarAction.toString(): {
      return {
        ...state,
        isFetchingStartWebinar: true,
        startWebinarError: null
      };
    }

    case startWebinarAction.complete.toString(): {
      return {
        ...state,
        isFetchingStartWebinar: false,
        startWebinarError: null
      };
    }

    case startWebinarAction.failed.toString(): {
      return {
        ...state,
        isFetchingStartWebinar: false,
        startWebinarError: action.message
      };
    }

    /* ------------ Series Recurrence ----------------- */
    case getSeriesRecurrenceAction.toString(): {
      return {
        ...state,
        isFetchingRecurrenceSeries: true
      };
    }

    case getSeriesRecurrenceAction.complete.toString(): {
      const seriesRecurrence = Object.assign({}, state.seriesRecurrence);
      seriesRecurrence[action.recurrenceKey] = action.data;
      return {
        ...state,
        seriesRecurrence,
        isFetchingRecurrenceSeries: false
      };
    }

    case getSeriesRecurrenceAction.failed.toString(): {
      return {
        ...state,
        recurrenceError: action.message,
        isFetchingRecurrenceSeries: false
      };
    }

    case getFutureSeriesRecurrenceAction.toString(): {
      return {
        ...state,
        isFetchingRecurrenceSeries: true
      };
    }

    case getFutureSeriesRecurrenceAction.complete.toString(): {
      const futureSeriesRecurrence = action.data;
      return {
        ...state,
        futureSeriesRecurrence,
        isFetchingRecurrenceSeries: false
      };
    }

    case getFutureSeriesRecurrenceAction.failed.toString(): {
      return {
        ...state,
        recurrenceError: action.message,
        isFetchingRecurrenceSeries: false
      };
    }

    case updateSeriesRecurrenceAction.toString(): {
      return {
        ...state,
        isUpdatingRecurrenceSeries: true
      };
    }

    case updateSeriesRecurrenceAction.complete.toString(): {
      const { seriesRecurrence, upcomingWebinar } = updateRecurrenceDetails(state, action);
      return {
        ...state,
        seriesRecurrence,
        upcomingWebinar: {
          ...state.upcomingWebinar,
          data: upcomingWebinar
        },
        isUpdatingRecurrenceSeries: false
      };
    }

    case updateSeriesRecurrenceAction.failed.toString(): {
      return {
        ...state,
        recurrenceError: action.message,
        isUpdatingRecurrenceSeries: false
      };
    }

    case updateSimuliveRecording.toString(): {
      return {
        ...state,
        isUpdatingSimuliveRecording: true
      };
    }

    case updateSimuliveRecording.failed.toString():
    case updateSimuliveRecording.complete.toString(): {
      return {
        ...state,
        isUpdatingSimuliveRecording: false
      };
    }

    case addSimuliveRecordingAction.toString(): {
      const recording = action.selectedRecording;
      recording.webinarKey = action.webinarKey;
      return {
        ...state,
        simuliveRecording: {
          data: recording
        }
      };
    }
  }
};
